import { FC, useEffect, useState } from 'react';

import classes from './AddServicesModal.module.css';
import { IOtherService } from '../AdditionalServicesTab';
import plusIcon from '../../../../assets/icons/plus-icon.svg';
import checkIcon from '../../../../assets/icons/check-icon.svg';
import { client } from '../../../../networking/client';
import searchIcon from '../../../../assets/icons/search.svg';
import { useTranslation } from '../../../../hooks/useTranslations';

interface Props {
  otherServices: IOtherService[];
  servicesSelected: IOtherService[];
  onAddService: (service: IOtherService) => void;
  onRemoveService: (service: IOtherService) => void;
  workOrderId: number | undefined;
  onServicesAddedHandler: () => void;
}

const AddServices: FC<Props> = ({
  otherServices,
  servicesSelected,
  onRemoveService,
  workOrderId,
  onServicesAddedHandler,
}) => {
  const { translations } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchedServices, setSearchedServices] = useState<IOtherService[]>([]);

  useEffect(() => {
    setSearchedServices(
      otherServices.filter((os) => os.service_name.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [searchTerm, otherServices]);

  const handleAddingServices = async (serviceId: string) => {
    if (!workOrderId) return;
    try {
      await client.post('/healthpoint/medical-service', {
        workOrderId: workOrderId,
        serviceId: parseInt(serviceId),
      });
      onServicesAddedHandler();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.searchContainer}>
        <input
          type="text"
          value={searchTerm}
          className={classes.searchInput}
          placeholder={`${translations('search') ?? ''}...`}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
        <img className={classes.searchIcon} src={searchIcon} alt="search" />
      </div>
      <div className={classes.servicesList}>
        {searchedServices.map((os) => (
          <div key={os.service_id} className={classes.serviceContainer}>
            <div className={classes.label}>
              <span>#{os.service_id}</span> - {os.service_name}
            </div>
            {servicesSelected.includes(os) ? (
              <img
                src={checkIcon}
                alt="check icon"
                className={classes.serviceActionButton}
                onClick={() => onRemoveService(os)}
              />
            ) : (
              <img
                src={plusIcon}
                alt="add icon"
                className={classes.serviceActionButton}
                onClick={() => handleAddingServices(os.service_id)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddServices;
